<template>
  <div>
    <div class="card shadow">
      <a id="button"></a>
      <div class="card-header bg-transparent">
        <div>
          <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>         
          <h3 class="mb-0">
            {{ $t('message.Addligne') }}
          </h3>
        </div>
      </div>

      <div class="">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
              <div class="form-group col-md-12">
                  <span class="obligatoire">*</span>
                  <label for="plainte" class="typo__label">{{ $tc('message.complaints',2) }}</label>
                  <multiselect v-model="form.plaintes" id="plainte" tag-placeholder="Ajouter une nouvelle plainte" :taggable="true" @tag="addTag" label="description" track-by="id" placeholder="Rechercher ou ajouter une plainte" :options="liste_plaintes" :multiple="true" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getMotifs">
                      <template slot="clear" slot-scope="props">
                          <div class="multiselect__clear" v-if="$v.form.plaintes.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
                      </template><span slot="noResult">{{ $t('message.addComplaints') }}</span>
                  </multiselect>
                  <span v-if="Plainterrors.length" style="color:red">
                    <span v-for="index in Plainterrors" :key="index">{{ index }}</span> 
                  </span>

                  <!-- <small id="emailHelp" class="form-text text-danger">{{ errors.has('plaintes') ? "Les plaintes sont requises" : "" }}</small>  -->
              </div>
              
              <b-col sm="12">
                  <span  class="obligatoire">*</span>
                  <b-form-group 
                      id="consultation-group"
                      :label="$t('message.consultationDate')"
                      label-for="consultation"
                      description="">
                  <b-form-input
                      id="consultation"
                      v-model="$v.form.date_consultation.$model"
                      :state="$v.form.date_consultation.$dirty ? !(errorshasField('date_consultation') || $v.form.date_consultation.$error) : null"
                      type="date"
                      required
                      @focus="clearErrorField('date_consultation')"
                  ></b-form-input>

                  <span v-if="Dateerrors.length" style="color:red">
                    <span v-for="index in Dateerrors" :key="index">{{ index }}</span> 
                  </span>

                  </b-form-group>
                </b-col>
                <div v-if="this.file.affiliation.length > 0">
                  <b-col sm="12">
                    <span  class="obligatoire">*</span>
                    <b-form-group id="affiliation_id-group" :label="$t('message.affiliation')" label-for="affiliation_id">
                        <select id="affiliation_id" v-model="$v.form.affiliation_id.$model"
                            :required="type == 2"
                            @change="clearErrorField('affiliation_id')"
                            class="custom-select">
                            <option value="" selected>{{ $t('message.selectAffiliation') }}</option>
                            <option v-for="item in this.file.affiliation" :key="item.id" :value="item.id">
                                {{ item.package.description_fr }} ({{ item.date_signature }})
                            </option>
                        </select>
                        <b-form-invalid-feedback v-if="$v.form.affiliation_id.$error">
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>
                        <span v-if="Affiliationerrors.length" style="color:red">
                          <span v-for="index in Affiliationerrors" :key="index">{{ index }}</span> 
                        </span>
                    </b-form-group>
                  </b-col>
                </div>

                <!-- <b-col sm="12">
                    <div>
                        <b-form-checkbox
                        id="etat"
                        v-model="$v.form.etat.$model"
                        name="etat"
                        value="1"
                        :checked="etat"
                        >
                        Status de la ligne de temps
                        </b-form-checkbox>
                        <div> Status: <strong>{{ etat }}</strong></div>
                    </div>
                        <b-form-invalid-feedback v-if="!$v.form.etat.required">
                        {{ $t('message.requiredField') }}
                    </b-form-invalid-feedback>
                </b-col> -->
                <div class="d-flex justify-content-center" v-if="isLoading">
                    <div class="loading"></div>
                </div>
                <b-row class="d-flex justify-content-center" v-else>
                    <b-button @click="onSubmit" variant="primary" v-if="can">
                        {{ $t('message.save') }}
                    </b-button>
                </b-row>
          </b-form>    
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required,minLength } from 'vuelidate/lib/validators';
import _ from 'lodash';
import SlimSelect from 'slim-select';
import moment from 'moment';
import $ from 'jquery';
import axios from 'axios';
import AppConfig from "../../constants/AppConfig";
import Multiselect from 'vue-multiselect'

export default {
  name: "AddTimeline",

  components: { Multiselect },

  computed: {
    ...mapGetters([
      "errors",
      'hasAdminRole',
      'file',
      'hasMedecinControleRole',
      'hasAssistante',
      'hasPraticienRole']),

    mMedicalFile: function () {
        return (_.isUndefined(this.file) || _.isNull(this.file)) ? null : this.file;
    },

     can: function () {
      if (this.hasAdminRole) {
        return true;
      } else {
        return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
      }
    },

    today: function () {
      return moment((new Date())).format('YYYY-MM-DD');
    },
  },

  data() {
    return {
      etat: 1,
      isLoading: false,
      liste_plaintes: [],
      loading: false,
      affiliations: [],
      file_id: this.$route.params.file,
      patient_id: localStorage.setItem('patient_id', this.$route.params.patient_id),
      statut: true,
      watch: {
        etat: function (oldValue, newValue) {
          if (newValue == true) {
            this.form.etat = "1";
          }
        },

      },

      form: {
        etat: true,
        affiliation_id: null,
        plaintes: [],
        date_consultation: this.today,
      },


      show: true,
      Plainterrors: [],
      Dateerrors: [],
      Affiliationerrors: [],
    }
  },

  methods: {
    addTag (newTag) {
        const tag = {
            id: "item_"+newTag,
            description: newTag
        }
        this.liste_plaintes.push(tag)
        this.form.plaintes.push(tag)
    },
    getMotifs(motif){
      this.loading = true;
      fetch(AppConfig.apiUrl+`/search/motif/${motif}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
          .then(res => res.json())
      .then(res => {
           this.loading = false;
          this.liste_plaintes = res.motifs.map(item => ({id: item.id, description: item.description})).filter(item => item.description != "" && item.description != "[object Object]");
      }).catch(error => {
          console.log('error ', error);
      })
    },
    clearAll () {
        this.form.plaintes = []
    },
      getTimelines: function() {
      let args = {};
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      this.$store.dispatch('getTimelines', { args, errorMessages });
    },
    pathTo(element) {
      if (this.$route.fullPath.includes('#')) {
        let position = this.$route.fullPath.search('#');
        return this.$route.fullPath.substr(0, position) + element;
      }
      return this.$route.fullPath + element;
    },

    getMedicalFile() {
        let args = {
            file: this.$route.params.file
        };

        this.$store.dispatch("getMedicalFile", {
            args
        });
    },
    // getAffiliation(){
    //     // if(this.mMedicalFile != null){
    //       axios.get(`${AppConfig.apiUrl}/true_affiliations/${this.file.patient_id}`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
    //       .then(res => {
    //           console.log(res);
    //           this.affiliations = res.data;
              
    //           // console.log('res.data.affiliations ', res.data.affiliations)
    //       })
    //       .catch((error) => {
    //               console.log("error ", error)
    //       });
    //   // }
    // },

    getMedicalValue(item) {
        return this.mMedicalFile.hasOwnProperty(item) ? this.mMedicalFile[item] : "";
    },


    onSubmit: function (evt, button) {
      evt.preventDefault();
      // this.isLoading = true;

      this.Plainterrors = [];
      this.Dateerrors = [];
      this.Affiliationerrors = [];

      if (!_.isNull(this.form.dateRdv)){
        this.form.dateRdv = moment(this.form.dateRdv).format('YYYY-MM-DD HH:mm');
      }
      // console.log(args);
      
      if (!this.form.affiliation_id) {
        this.Affiliationerrors.push('Veuillez selectionnez l\'affiliation');
      }
      if (this.form.plaintes.length == 0) {
        this.Plainterrors.push('Veuillez ajouter une plainte');
      }

      if (!this.form.date_consultation) {
        this.Dateerrors.push('Veuillez selectionner la date de consultation');
      }
      
      if(this.file.affiliation.length > 0){
        if(this.form.affiliation_id && this.form.plaintes.length > 0 && this.form.date_consultation){
          this.isLoading = true;
          let formData = new FormData();
          formData.append('date_consultation', this.form.date_consultation);
          formData.append("plaintes", this.form.plaintes.map(item => item.id));
          formData.append('etat', 1);
          formData.append('dossier_medical_id', this.file.id);
          formData.append('affiliation_id', this.form.affiliation_id);

          let successMessage = this.$i18n.t('message.TimelineCreated');
          let errorMessages = {
            generic: this.$i18n.t('message.genericError'),
            error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
          };
          this.$store.dispatch('createTimeline', {args: formData, errorMessages, successMessage}).then(() => {
            this.$router.push((this.$router.resolve({ name: 'medical-file',  params: { file: this.file_id }})).href +  '#generale');
          });
        }
      }else{
        if(this.form.plaintes.length > 0 && this.form.date_consultation){
          this.isLoading = true;
          let formData = new FormData();
          formData.append('date_consultation', this.form.date_consultation);
          formData.append("plaintes", this.form.plaintes.map(item => item.id));
          formData.append('etat', 1);
          formData.append('dossier_medical_id', this.file.id);

          let successMessage = this.$i18n.t('message.TimelineCreated');
          let errorMessages = {
            generic: this.$i18n.t('message.genericError'),
            error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
          };
          this.$store.dispatch('createTimeline', {args: formData, errorMessages, successMessage}).then(() => {
            this.$router.push((this.$router.resolve({ name: 'medical-file',  params: { file: this.file_id }})).href +  '#generale');
          });
        }
        
      }
    },

    onReset: function (evt) {
      evt.preventDefault();

      // Reset our form values
      this.form.dossier_medical_id = '';
      this.form.motif_consultation_id = [''];
      this.date_consultation = '';

      // Trick to reset/clear native browser form validation state
      this.show = false; 
      this.isLoading = false;

      this.$nextTick(() => {
        this.show = true;
      });
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return '';
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch('clearErrorField', {field});

      this.getErrorsField(field);
    }
  },

  validations() {
    return {
      form: {
        plaintes: {
          required
        },
        date_consultation: {
          required
        },
        etat:{},
        affiliation_id: {
          // required
        }
      }
    }
  },

  mounted() {
      localStorage.setItem('reload', 0);
    // Fetch reason list
    //this.getReasons();
    
    this.getMedicalFile();
    // this.getAffiliation();
    // this.getListOfMedicalAdvices();

    this.$v.form.date_consultation.$model = this.today;


    var btn = $('#button');

    $(window).scroll(function () {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: 0}, '300');
    });
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>